<template>
  <h2 style="text-align: center;">Materials</h2>
  <form class="card col-md-6 offset-md-3">
    <div class="row p-2">
      <div class="col-md-4">
        <label class="form-text"> Name </label>
        <input class="form-control" type="text" v-model="materialNameNew" />
      </div>
      <div class="col-md-6">
        <label class="form-text"> Fonts to exclude </label>
        <vue-select
          style="width: 100%; display: inline-block;"
          :options="fontSource"
          :min="1"
          label-by="fontName"
          value-by="fontID"
          searchable
          :model-value="fontsToExcludeNew"
          @update:modelValue="(value) => {
          if (value !== null && value !== undefined) { 
          fontsToExcludeNew = value
          }
          }"
          multiple
          taggable
        >
          <template #label="{ selected }">
            <template v-if="selected">
              <div class="dd-color">
                {{ selected.fontName }}
              </div>
            </template>
            <template v-else>
              <div class="dd-color">no select</div>
            </template>
          </template>
          <template #dropdown-item="{ option }">
            <div class="dd-color">
              {{ option.fontName }}
            </div>
          </template>
        </vue-select>
      </div>

      <div class="col-md-2 p-3" title="Add material">
        <icon-svg
          icon="material-symbols:add-circle-outline"
          :height="35"
          :width="35"
          style="cursor: pointer"
          @click="addMaterial()"
        />
      </div>
    </div>
  </form>

  <div class="row mt-2">
    <div class="col-md-8">
      <table class="table responsive-table">
        <thead>
          <tr>
            <th>Material Name</th>
            <th>Fonts to exclude</th>
            <th>remove</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(material, index) in store.getAllMaterials()" :key="index">
            <td>{{ material.materialName }}</td>
            <td>{{ getAllFontsExcludeName(material) }}</td>
            <td title="delete material">
              <icon-svg
                :height="25"
                :width="25"
                icon="ic:baseline-delete"
                style="cursor: pointer"
                @click="removeMaterial(material.materialID)"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>


<script>
import { designerStore } from "@/stores/designerStore";
import VueSelect from "vue-next-select";

export default {
  name: "App",
  setup() {
    const store = designerStore();
    return {
      store,
    };
  },

  components: {
    VueSelect,
  },
  data() {
    return {
      materialNameNew: "",
      fontsToExcludeNew: [],
      fontSource: [],
    };
  },
  mounted() {
    this.fontSource = this.store
      .getAllFonts()
      .map((x) => ({ fontID: x.fontID, fontName: x.fontName }));
  },
  methods: {
    addMaterial() {
      this.store.addMaterial(this.materialNameNew, this.fontsToExcludeNew);
      this.materialNameNew = "";
      this.fontsToExcludeNew = [];
    },
    getFontsNamesFromMaterial(material) {
      return material.fontsToExclude.map((x) => x.fontName).join(" , ");
    },
    removeMaterial(materialID) {
      this.store.removeMaterial(materialID);
    },
    getAllFontsIDAndName() {
      return this.store
        .getAllFonts()
        .map((x) => ({ fontID: x.fontID, fontName: x.fontName }));
    },
    getAllFontsExcludeName(material) {
      return Object.values(material.fontsToExcludeID)
        .map((x) => this.store.allFonts.value[x].fontName)
        .join(" , ");
    },
  },
};
</script>


<style>
/* .vue-select-header {
  position: relative !important;
} */
.vue-tag, .vue-tag.selected {
  font-size: 1.2rem !important;
}
</style>